var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Directive, Renderer, ElementRef } from '@angular/core';
var InputFocusedDirective = (function () {
    function InputFocusedDirective(renderer, elementRef) {
        this.renderer = renderer;
        this.elementRef = elementRef;
    }
    InputFocusedDirective.prototype.ngOnInit = function () {
        this.renderer.invokeElementMethod(this.elementRef.nativeElement, 'focus', []);
    };
    InputFocusedDirective = __decorate([
        Directive({
            selector: '[focused]'
        }),
        __metadata("design:paramtypes", [Renderer, ElementRef])
    ], InputFocusedDirective);
    return InputFocusedDirective;
}());
export { InputFocusedDirective };
//# sourceMappingURL=input-focused.directive.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/input-focused.directive.js
// module id = 808
// module chunks = 0